import { z } from 'zod';
import type { TicketField } from '../entities';
import { TicketFieldType } from '../entities';
import {
  getIntegerFieldValidator,
  getDecimalFieldValidator,
  getDateFieldValidator,
  getPartialCreditCardFieldValidator,
  getCheckboxFieldValidator,
  getRegexpFieldValidator,
  getLookupFieldValidator,
  getDefaultFieldValidator,
} from './fieldValidators';

export const getFieldValidator = (field: TicketField): z.ZodTypeAny => {
  const isRequired = field.required;

  switch (field.type) {
    case TicketFieldType.INTEGER:
      return getIntegerFieldValidator({ isRequired });
    case TicketFieldType.DECIMAL:
      return getDecimalFieldValidator({ isRequired });
    case TicketFieldType.DATE:
      return getDateFieldValidator({ isRequired });
    case TicketFieldType.PARTIALCREDITCARD:
      return getPartialCreditCardFieldValidator({ isRequired });
    case TicketFieldType.CHECKBOX:
    case TicketFieldType.MULTISELECT:
      return getCheckboxFieldValidator({ isRequired });
    case TicketFieldType.REGEXP:
      return getRegexpFieldValidator({ field, isRequired });
    case TicketFieldType.LOOKUP:
      return getLookupFieldValidator({ isRequired });
    default:
      return getDefaultFieldValidator({ isRequired });
  }
};
